import styled from 'styled-components';

import { WarningBasicIcon } from '@genially/icons';

import { ResponsiveText } from '../../../../../../../../shared/application/components/ResponsiveText/ResponsiveText';

export const Wrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  gap: size.units(1.5),
}));

interface PlayersTitleProps {
  $showWarning?: boolean;
}

export const PlayersTitle = styled(ResponsiveText)<PlayersTitleProps>(
  ({ theme: { color }, $showWarning }) => ({
    color: $showWarning
      ? color.content.warning.default()
      : color.content.reversed.default(),

    textAlign: 'center',
  }),
);

export const StyledWarningIcon = styled(WarningBasicIcon)(
  ({ theme: { color, size } }) => ({
    color: color.content.warning.default(),
    width: size.units(2),
    height: size.units(2),
    minWidth: size.units(2),
    minHeight: size.units(2),
  }),
);
